import { Injectable } from '@angular/core';
import { StoredGeoResponse } from 'src/app/interfaces/geo-interface';
import { ConfigService } from '../config/config.service';
import { isUndefined } from '../codeUtils';
import { WebservicesService } from '../webservices/webservices.service';
import { Subject } from 'rxjs';
import { GeoLocationSDKInitService } from './geo-location-sdkinit.service';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class GeoLocationSchedulerService {

  private FEATURE_GEOCOMPLY_OPTION_IPCHECK: boolean = true;
  private FEATURE_GEOCOMPLY_BUFFERTIME: number = 30;
  private FEATURE_GEOCOMPLY_OPTION_IPCHECK_INTERVAL = 30;
  //private FEATURE_GEOCOMPLY_USE_IP_CHECK_SERVICE: boolean = false;
  private checkIPIntervalId: any;
  private _cached_geoResponse: StoredGeoResponse;
  private ipChangeSubject = new Subject<void>();
  private useNDBSSolution: boolean;

  constructor(
    private configService: ConfigService,
    private webservices: WebservicesService,
    private utilsService: UtilsService,
    private geoLocationSDKInitService: GeoLocationSDKInitService
  ) {
    const configMap = this.configService.getConfig();
    this.FEATURE_GEOCOMPLY_OPTION_IPCHECK = this.configService.isFeatureON(configMap, "FEATURE_GEOCOMPLY_OPTION_IPCHECK", true);
    this.FEATURE_GEOCOMPLY_BUFFERTIME = Number(configMap['FEATURE_GEOCOMPLY_BUFFERTIME']) || 120;
    this.FEATURE_GEOCOMPLY_OPTION_IPCHECK_INTERVAL = Number(configMap['FEATURE_GEOCOMPLY_OPTION_IPCHECK_INTERVAL']) || 30;
    this.useNDBSSolution = this.configService.isFeatureON( configMap, "FEATURE_GEOCOMPLY_USENODOWNLOAD", undefined);
    //this.FEATURE_GEOCOMPLY_USE_IP_CHECK_SERVICE = this.configService.isFeatureON(configMap, "FEATURE_GEOCOMPLY_USE_IP_CHECK_SERVICE", false);
  }

  public storeGeoLocationResponse(geoResponse: StoredGeoResponse): void {
    this._cached_geoResponse = geoResponse;
  }

  public async isGeoLocationValid(): Promise<boolean> {
    // Check if _cached_geoResponse is undefined
    if (isUndefined(this._cached_geoResponse)) {
      return false; // Return false if no cached response
    }
    const geoLocationStatus = this._cached_geoResponse.geoResponse.is_allowed;
    const cachedGeoLocationExpiry = this._cached_geoResponse.expiry_ts;
    console.log('************GeoLocation Status************', geoLocationStatus);
    console.log('************Cached GeoLocation Expiry************', cachedGeoLocationExpiry);

    if (geoLocationStatus && cachedGeoLocationExpiry > new Date().getTime()) {
      return true;
    }

    return false;
  }

  public setBufferTime(): number {
    return
  }

  public getBufferTime(geolocate_in: number): number {
    const platformInfo = this.utilsService.getPlatformInfo();
    let bufferTimeForPopup = platformInfo.isAndroidMobileWeb ? 30 : 0;
    if (geolocate_in < this.FEATURE_GEOCOMPLY_BUFFERTIME) {
      return Math.min(geolocate_in * (30.0 / 100.0), bufferTimeForPopup + this.FEATURE_GEOCOMPLY_BUFFERTIME);
    } else {
      return Math.min(geolocate_in / 2, bufferTimeForPopup + this.FEATURE_GEOCOMPLY_BUFFERTIME);
    }
  }

  public startIPCheck(data): void {
    //if (!this.FEATURE_GEOCOMPLY_USE_IP_CHECK_SERVICE) {
      if (this.checkIPIntervalId) {
        clearInterval(this.checkIPIntervalId);  // Clear any existing interval
      }
      if (this.FEATURE_GEOCOMPLY_OPTION_IPCHECK) {
        this.checkIPIntervalId = setInterval(() => {
          console.log('************Running IP check...************');
          this.getIPStatusFromServer(data).then((geoIsOkay: boolean) => {
            if (!geoIsOkay) {
              console.log(
                "%cGeolocation: IP change detected, will perform geo check again",
                "color: red; font-weight: bold"
              );
              // Reschedule the next geo check immediately after IP change detection
              this.ipChangeSubject.next();
            }
          }).catch((error) => {
            console.log('************Error during IP check************', error);
          });
        }, this.FEATURE_GEOCOMPLY_OPTION_IPCHECK_INTERVAL * 1000)
      }
    //Not for this Scope - Work In Progress
    /*} else {
      const geoComplyClient = this.geoLocationSDKInitService.getGeoComplyWindowClient();
      geoComplyClient.startMyIpService(true);
      const ackMyIPSuccess = (data) => geoComplyClient.ackMyIPSuccess(data);
      geoComplyClient.on('my_ip_success', (ip) => {
        console.log('IP CHange Detected. New IP: ', ip);
        //Need to go through documentation for this part it's not clear how exactly to use ackMyIPSuccess()
        ackMyIPSuccess(ip);
        this.ipChangeSubject.next();
      })
    }*/
  }

  public stopIPCheck(): void {
    //if (!this.FEATURE_GEOCOMPLY_USE_IP_CHECK_SERVICE) {
      if (this.checkIPIntervalId) {
        clearInterval(this.checkIPIntervalId);
        this.checkIPIntervalId = null;
      }
   //Not for this Scope - Work In Progress
   /* }
    else {
      console.log('---inside stop ip----')
      const geoComplyClient = this.geoLocationSDKInitService.getGeoComplyWindowClient();
      geoComplyClient.stopMyIpService();
    }*/
  }

  get ipChange$() {
    return this.ipChangeSubject.asObservable();
  }

  private getIPStatusFromServer(data): Promise<boolean> {
    return new Promise(async (resolve) => {
      this.webservices.post("geoComply/check", {
        customer_id: data.customerID,
        session_token: data.sessionToken,
      }).toPromise().then(() => {
        resolve(true);
      })
        .catch((reason: any) => {
          console.log("************Geolocation: Check failed!************", reason);
          resolve(false);
        });
    });
  }

  public killConnection(): void {
    this.stopIPCheck();
    const platformInfo = this.utilsService.getPlatformInfo();
    if(platformInfo.isDesktopWeb && !this.useNDBSSolution){
      const geoComplyClient = this.geoLocationSDKInitService.getGeoComplyWindowClient();
      if (geoComplyClient) {
        geoComplyClient.off('connect');
        geoComplyClient.off('error');
        geoComplyClient.off('geolocation');
        geoComplyClient.off('log');
        geoComplyClient.disconnect();
      }
    }
   
  }

  /**
   * Reserved function which client can use to utilize based on server response through notification or specific method for GeoLocation
   */
  public getResponseFromServerSpecialAction(): void {

  }
}
